module.exports = "/fonts/boxicons.ttf?f46ca69e63f9c5f080203c3f510b4110";